import { inject } from "fw";
import { createFrom } from "fw-model";
import { CommonAppTransferSearchResult } from "models/common-app-transfers";
import { Manager } from "./manager";

@inject
export class CommonAppIntegrationRepository {
    constructor(private s: Manager) {}

    public async commonAppTransferHistory(
        filter: string,
        search: string = null,
        sort: string = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        fieldsPaths: string = null,
        aggs: string = null,
        aggregationsOnly: boolean = false,
        pageSize: number = 20
    ): Promise<CommonAppTransferSearchResult> {
        const res = await this.s.get<CommonAppTransferSearchResult>("common-app-transfer/history", {
            filter,
            search,
            sort,
            pageSize,
            previousPageToken,
            nextPageToken,
            aggs,
            fieldsPaths,
            aggregationsOnly
        });
        return createFrom(CommonAppTransferSearchResult, res.body);
    }
}
